import { Flex, Input, Paper, Slider, SliderProps, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'

// slider uses exponents of 2 internally, props accept/return actual GB values
// https://mantine.dev/core/slider/#scale
const MIN_EXP = 3 // 8 GB
const MAX_EXP = 11 // 2048 GB

const scale = (v: number) => 2 ** v
const formatLabel = (gb: number) => `${gb} GB`

type StorageLimitSliderProps = Omit<
  SliderProps,
  'min' | 'max' | 'step' | 'label' | 'marks' | 'scale' | 'defaultValue'
>

export const StorageLimitSlider = ({
  value,
  onChange,
  ...props
}: StorageLimitSliderProps) => {
  // convert GB to exponent for internal slider position
  const exp = typeof value === 'number' ? Math.log2(value) : value

  return (
    <Input.Wrapper
      label={<FormattedMessage id="vlm.hardware.settings.storageLimit" />}
      description={
        <FormattedMessage id="vlm.hardware.settings.storageLimit.description" />
      }
    >
      <Paper px={16} pt={30} pb={10} withBorder>
        <Slider
          size="sm"
          min={MIN_EXP}
          max={MAX_EXP}
          step={1}
          scale={scale}
          label={formatLabel}
          labelAlwaysOn
          {...props}
          value={exp}
          onChange={(v) => onChange?.(2 ** v)}
        />
        <Flex justify="space-between" mt="xs">
          <Text size="xs" fw={700}>
            {formatLabel(scale(MIN_EXP))}
          </Text>
          <Text size="xs" fw={700}>
            {formatLabel(scale(MAX_EXP))}
          </Text>
        </Flex>
      </Paper>
    </Input.Wrapper>
  )
}
